export default function thumbor(url, params = '') {
	let newUrl = "https://capimg.capitual.net/" + params + '/'

	url = url.replace("https://usercontent.capitual.net/", newUrl)

	return url
}